<template>
  <div class="pt-4 pb-2">
    <section-title content="Detalles del Servicio" :has-line="true" />
    <div class="bg-light-gray py-4 rounded">
      <validation-observer ref="assistantForm">
        <div class="col-12">
            <span class="bg-gray-2 p-2 badge-radius color-white">
              Asistente de Servicio
            </span>
            <div
              v-for="(question, idx) of questions"
              :key="`question-${idx}`"
              class="mb-3 mt-4"
            >
              <ordered-header-card
                v-if="question.id === 1 || hasCompletedAssistanceServiceRequest"
                class="ordered-header-card__extended"
                :class="{ disabled: isReadOnly }"
                :order="idx + 1"
              >
                <div slot="content">
                  <div class="py-3">{{ question.text }}</div>
                </div>
                <div slot="actions">
                  <div class="d-flex flex-column flex-md-row align-items-center">
                    <div v-if="question.answerOptions">
                      <validation-provider v-slot="{ errors }" rules="required">
                        <custom-radio
                          v-model="question.model.selected"
                          :change-event="
                            (event) => {
                              onChangeQuestion(event, question);
                            }
                          "
                          class="custom-question__extended"
                          :class="{ disabled: isReadOnly }"
                          :custom-error-msg="question.validationMessage"
                          :disabled="isReadOnly"
                          :error="errors[0]"
                          is-question-list
                          name="rbCompensatory"
                          :options="question.answerOptions"
                        />
                      </validation-provider>
                    </div>
                    <div v-if="hasCheckCompleteRequest(question)" class="mb-3">
                      <validation-provider
                        v-slot="{ errors }"
                        :rules="{ required: !question.model.hasDate }"
                      >
                        <custom-date-picker
                          v-model="model.serviceRequestedDate"
                          custom-error-msg="Favor seleccione la fecha"
                          :disabled="question.model.hasDate || isReadOnly"
                          :error="errors[0]"
                          :max-date="new Date()"
                          placeholder="DD/MM/YYYY"
                          right
                          @input="onChange()"
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </ordered-header-card>
            </div>
          </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import CustomDropDown from "custom-drop-down";
import ActionButton from "ActionButton";
import CustomDatePicker from "custom-date-picker";
import OrderedHeaderCard from "ordered-header-card";
import CustomRadio from "custom-radio";
import CustomTextArea from "CustomTextArea";
import SectionTitle from 'SectionTitle';
import rpServiceTypes from '@/utils/constants/rp/rpServiceTypes';

const ANSWERS = {
  YES: 1,
  NO: 2,
  NOSE: 3
}

const QUESTIONS = {
  CompletedServiceAssistant: 1,
  IsTransportationService: 3
}
export default {
  name: "AssistantService",
  components: {
    CustomDropDown,
    ActionButton,
    CustomDatePicker,
    OrderedHeaderCard,
    CustomRadio,
    CustomTextArea,
    SectionTitle,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    isTransportationNecesitySelected: {
      type: Boolean,
      default: () => false,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(newVal) {
        if (newVal && Object.keys(newVal).length) {
          this.model = {
            ...this.model,
            ...newVal,
          };

          this.questions = this.questions.map((item, i) => {
            //assistance service
            if (i === 0) {
              item.model = {
                selected: newVal.serviceRequestedAnswerId,
              };
              (
                item.answerOptions.find(
                  (x) => x.id === newVal.serviceRequestedAnswerId
                ) || {}
              ).check = true;
            }

            //transportationFlag
            if (i === 2) {
              item.model = {
                selected: item.id,
              };
              if (newVal.transportationFlag) {
                item.answerOptions[0].check = true;
              } else {
                item.answerOptions[1].check = true;
              }
            }
            return item;
          });
        }
      },
    },
  },
  data: () => ({
    model: {
    },
    questions: [
      {
        id: 1,
        text: "¿Se completó la solicitud de Asistente de Servicio?",
        model: {},
        validationMessage: "Favor seleccione si, no ó no sé.",
        answerOptions: [
          {
            id: 1,
            label: "SI",
            check: null,
            disabled: null,
          },
          {
            id: 2,
            label: "NO",
            check: null,
            disabled: null,
          },
          {
            id: 3,
            label: "NO SÉ",
            check: null,
            disabled: null,
          },
        ],
      },
      {
        id: 2,
        text: "Si conoce, indique la fecha de solicitud",
        model: {},
      },
      {
        id: 3,
        text: "¿Es para servicio de transportación?",
        model: {},
        validationMessage: "Favor seleccione si o no.",
        answerOptions: [
          {
            id: 1,
            label: "SI",
            check: null,
            disabled: null,
          },
          {
            id: 2,
            label: "NO",
            check: null,
            disabled: null,
          },
        ],
      },
    ],
  }),
  mounted() {
    this.getQuestion(QUESTIONS.CompletedServiceAssistant).getAnswer(ANSWERS.YES).check = true;
    const transportationAnswerOption = this.isTransportationNecesitySelected ? ANSWERS.YES : ANSWERS.NO;
    this.getQuestion(QUESTIONS.IsTransportationService).getAnswer(transportationAnswerOption).check = true;
  },
  computed: {
    hasCheckCompleteRequest() {
      return (question) =>
        question.id === 2 && this.questions[0].answerOptions[0].check;
    },
    hasCompletedAssistanceServiceRequest() {
      return this.questions[0].answerOptions[0].check;
    },
  },
  methods: {
    getQuestion(id){
      const question = this.questions.find(x => x.id === id);
      if(!question) return question;
      
      question.getAnswer = (answerId) => question.answerOptions.find(x => x.id === answerId)

      return question;
    },
    getModel() {
      return {
        assistanceServiceFlag: true,
        serviceRequestedDate: this.model.serviceRequestedDate,
        serviceRequestedAnswerId: this.questions[0].answerOptions.find(
          (x) => x.check
        )?.id,
        transportationFlag: this.questions[2].answerOptions[0].check ?? false,
      };
    },
    validateService() {
      return this.$refs.assistantForm.validate();
    },
    onChange() {
      const service = {
        serviceTypeId: rpServiceTypes.AsistenteServiciosEnfermera,
        requestServiceAssistant: this.getModel()
      };
      this.$emit('update-service', service)
    },
    async onChangeQuestion(event, question) {
      question.model.selected = event.id;
      if (question.id === 1) {
        this.model.serviceRequestedDate = null;
      }
      await this.$forceUpdate();
      this.onChange();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';
.chip {
  border: 1px solid #b7c4bd;
  border-radius: 16px;
  display: flex;
  align-items: center;
  padding: 2px 4px 2px 14px;
  margin: 0 0.5rem 0.5rem 0.5rem;
}
.badge-radius {
  border-radius: 100px !important;
}

.ordered-header-card__extended ::v-deep {
  .bg-order {
    background: map-get($colors, "orange");
    border-radius: 5px 5px 0px 0px;
  }
}

.ordered-header-card__extended {
  &.disabled {
    .square-order {
      background: map-get($colors, "gray-11") !important;
    }
  }
}
</style>
